<template>

    <div>

        <b-card no-body class="mb-0">

            <div class="m-2">

                <b-row>

                    <b-col
                        cols="12"
                        md="4"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                        <label>Mostrar</label>
                        <v-select
                            v-model="perPage"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="perPageOptions"
                            :clearable="false"
                            class="per-page-selector d-inline-block mx-50"
                        />
                        <label>registros</label>
                    </b-col>

                    <b-col cols="12" md="6" class="ml-auto">
                        <div class="d-flex">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Buscar noticia ..."
                                trim
                            />
                            <b-button
                                variant="primary"
                                :to="{ name: 'news-create' }"
                                class="text-nowrap"
                            >
                                Agregar
                            </b-button>
                        </div>
                    </b-col>
                </b-row>

            </div>

            <b-table
                ref="refNewsListTable"
                class="position-relative"
                :style="totalNews < 3 && totalNews > 0 ? 'height: 250px' : 'height: inherit'"
                :items="fetchNewsList"
                responsive
                :fields="tableColumns"
                primary-key="id"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="No se encontraron registros coincidentes"
                :sort-desc.sync="isSortDirDesc">

                <template #cell(display_order)="data">
                    <span v-if="data.item.display_order !== null && data.item.display_order !== undefined">{{ data.item.display_order }}</span>
                    <span v-else class="text-muted">-</span>
                </template>

                <template #cell(title)="data">
                    <b-media vertical-align="center">
                        <template #aside>
                            <b-img
                                v-if="data.item.image_url"
                                :src="data.item.image_url"
                                width="64"
                                height="40"
                                rounded
                                style="object-fit: cover;"
                                alt="portada"
                            />
                        </template>
                        <b-link
                            :to="{ name: 'news-edit', params: { id: data.item.id } }"
                            class="font-weight-bold d-block">
                            {{ data.item.title }}
                        </b-link>
                        <b-link
                            :href="data.item.url"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="small text-muted"
                        >
                            {{ data.item.url | truncate }}
                            <feather-icon icon="ExternalLinkIcon" size="12" />
                        </b-link>
                    </b-media>
                </template>

                <template #cell(source)="data">
                    <span v-if="data.item.source">{{ data.item.source }}</span>
                    <span v-else class="text-muted">-</span>
                </template>

                <template #cell(active)="data">
                    <b-badge pill :variant="data.item.active ? 'light-success' : 'light-danger'">
                        {{ data.item.active ? 'Visible' : 'Oculto' }}
                    </b-badge>
                </template>

                <template #cell(actions)="data">
                    <b-dropdown
                        variant="link"
                        no-caret
                        :right="$store.state.appConfig.isRTL">

                        <template #button-content>
                            <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                        </template>

                        <b-dropdown-item :to="{ name: 'news-edit', params: { id: data.item.id } }">
                            <feather-icon icon="EditIcon" />
                            <span class="align-middle ml-50">Editar</span>
                        </b-dropdown-item>

                        <b-dropdown-item v-if="!data.item.active" @click="activateNews(data.item.id)">
                            <feather-icon icon="EyeIcon" />
                            <span class="align-middle ml-50">Mostrar en la web</span>
                        </b-dropdown-item>

                        <b-dropdown-item v-else @click="desactivateNews(data.item.id)">
                            <feather-icon icon="EyeOffIcon" />
                            <span class="align-middle ml-50">Ocultar de la web</span>
                        </b-dropdown-item>

                        <b-dropdown-item @click="deleteNews(data.item.id)">
                            <feather-icon icon="TrashIcon" />
                            <span class="align-middle ml-50">Eliminar</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </template>

            </b-table>

            <div class="mx-2 mb-2">
                <b-row>

                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start">
                        <span class="text-muted">Mostrando {{ dataMeta.from }} al {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
                    </b-col>

                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end">

                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalNews"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item">

                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>

                    </b-col>

                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>

    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
    import { useToast } from 'vue-toastification/composition';
    import { onUnmounted } from '@vue/composition-api';
    import newsStoreModule from '../newsStoreModule';
    import VueSweetalert2 from 'vue-sweetalert2';
    import useNewsList from './useNewsList';
    import vSelect from 'vue-select';
    import store from '@/store';
    import Vue from 'vue';
    import 'animate.css';

    Vue.use(VueSweetalert2);

    export default {
        components: {
            vSelect
        },
        filters: {
            truncate(value) {
                if (!value) return '';
                return value.length > 60 ? `${value.substring(0, 60)}...` : value;
            }
        },
        setup() {

            // USE TOAST
            const toast = useToast();

            const NEWS_APP_STORE_MODULE_NAME = 'app-news';

            // REGISTER MODULE
            if (!store.hasModule(NEWS_APP_STORE_MODULE_NAME)) store.registerModule(NEWS_APP_STORE_MODULE_NAME, newsStoreModule);

            // UNREGISTER ON LEAVE
            onUnmounted(() => {
                if (store.hasModule(NEWS_APP_STORE_MODULE_NAME)) store.unregisterModule(NEWS_APP_STORE_MODULE_NAME);
            });

            const {
                fetchNewsList,
                tableColumns,
                perPage,
                currentPage,
                totalNews,
                dataMeta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                refNewsListTable,

                refetchData
            } = useNewsList();

            const showToast = (title, icon, variant) => {
                toast({
                    component: ToastificationContent,
                    props: { title, icon, variant }
                });
            };

            const activateNews = (id) => {
                store.dispatch('app-news/activateNews', { id })
                    .then(response => {
                        refetchData();
                        showToast(response.data.message, 'CheckIcon', 'success');
                    })
                    .catch(() => showToast('Error al publicar la noticia.', 'AlertTriangleIcon', 'danger'));
            };

            const desactivateNews = (id) => {
                store.dispatch('app-news/desactivateNews', { id })
                    .then(response => {
                        refetchData();
                        showToast(response.data.message, 'CheckIcon', 'success');
                    })
                    .catch(() => showToast('Error al ocultar la noticia.', 'AlertTriangleIcon', 'danger'));
            };

            const deleteNews = (id) => {
                Vue.swal({
                    title: '¿Estás seguro de eliminar la noticia?',
                    text: "¡Si no lo está, puede cancelar la acción!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, eliminar!',
                    cancelButtonText: 'Cancelar',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    showClass: {
                        popup: 'animate__animated animate__tada'
                    },
                    buttonsStyling: false
                }).then(result => {
                    if (result.value) {
                        store.dispatch('app-news/deleteNews', { id })
                            .then(response => {
                                refetchData();
                                showToast(response.data.message, 'CheckIcon', 'success');
                            })
                            .catch(() => showToast('Error al eliminar la noticia.', 'AlertTriangleIcon', 'danger'));
                    }
                });
            };

            return {
                fetchNewsList,
                tableColumns,
                perPage,
                currentPage,
                totalNews,
                dataMeta,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                refNewsListTable,

                refetchData,

                activateNews,
                desactivateNews,
                deleteNews
            }
        }
    }

</script>

<style lang="scss" scoped>

    .media {
        align-items: center;
    }

    .per-page-selector {
        width: 90px;
    }

</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    @import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
